import { render, staticRenderFns } from "./EventTextSection.vue?vue&type=template&id=02f01a30"
import script from "./EventTextSection.vue?vue&type=script&lang=ts"
export * from "./EventTextSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports